module.exports = __webpack_public_path__ + "img/cocktail-glasses.a42e95b8.png";